var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import axios from "axios";
import { BAlert, BButton, BCard, BForm, BFormGroup, BFormInput } from "bootstrap-vue";
import { ref } from "vue";
import { useRouter } from "vue-router/composables";
import { withPrefix } from "@/utils/redirect";
import { errorMessageAsString } from "@/utils/simple-error";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ChangePassword',
    props: {
        token: null,
        expiredUser: null,
        messageText: null,
        messageVariant: null
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        const confirm = ref(null);
        const current = ref(null);
        const password = ref(null);
        const message = ref(props.messageText);
        const variant = ref(props.messageVariant);
        function submit() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield axios.post(withPrefix("/user/change_password"), {
                        token: props.token,
                        id: props.expiredUser,
                        current: current.value,
                        password: password.value,
                        confirm: confirm.value,
                    });
                    router.push("/");
                }
                catch (error) {
                    variant.value = "danger";
                    message.value = errorMessageAsString(error, "Password change failed for an unknown reason.");
                }
            });
        }
        return { __sfc: true, props, router, confirm, current, password, message, variant, submit, BAlert, BButton, BCard, BForm, BFormGroup, BFormInput };
    }
});
